<template>
	<div>
		<article class="iv2-article">
			<Error403 v-if="research.open_type == 0" />

			<div v-else-if="research.open_type == 1">
				<LayoutTitle :research="research" />
				<LayoutPattern :research="research" />
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Error403 from "@/components/systems/Page403.vue";

import Meta from "@/mixins/MetaSettable";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Preview],

	components: {
		LayoutTitle,
		LayoutPattern,
		BaseLoading,
		Error403,
	},

	data() {
		return {
			research: [],
			loading: true,
		};
	},

	mounted() {
		if(this.$route.query.mode == 'preview') {
			this.axios.get("/preview/enquetes", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then((response) => {
				this.research = response.data;
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		}else{
			this.axios.get("/enquetes").then((response) => {
				this.research = response.data;
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		}
	},
};
</script>

<style lang="scss">
</style>
